/**
 * 予約タスク一覧に表示する予約の対象期間の設定（施設ごとに1件）
 *
 * 全期間を選択していても、日数指定へ戻したときに復元できるよう日数は常に保持される
 */
export type ReservationTaskSetting = {
  hotelId: string
  newCheckinDays: number
  updatedCheckinDays: number
  canceledCheckinDays: number
  isNewAllPeriod: boolean
  isUpdatedAllPeriod: boolean
  isCanceledAllPeriod: boolean
}

/** 対象施設は backend が認証情報から決めるため、更新時は hotelId を送らない */
export type ReservationTaskSettingParams = Omit<ReservationTaskSetting, 'hotelId'>

// backend の TaskTargetPeriod::MIN_DAYS / MAX_DAYS と同じ値。backend の上限を変えたらここも揃える
export const RESERVATION_TASK_MIN_DAYS = 0
export const RESERVATION_TASK_MAX_DAYS = 365
